module.exports = __webpack_public_path__ + "assets/img/student.18fc0c5e.svg";